export const formatCodeType = (type: string | null | undefined) => {
    switch (type) {
        case 'multiselect':
            return 'Multiple Choice';
        case 'single':
        case 'simple':
            return 'Basic';
        case 'Input':
            return 'Input';
        default:
            return 'Unknown';
    }
};

export const formatCodeCategory = (category: string | null | undefined) => {
    switch (category) {
        case 'dx':
            return 'Diagnostic';
        case 'tx':
            return 'Treatment';
        case 'other':
            return 'Other';
        default:
            return 'Unknown';
    }
};
